import React from 'react';

function President() {
  return (
    <section id="president" className="leader-section leader-section--light">
      <div className="section-container">
        <div className="section-title-block">
          <h2 className="section-title">
             Message from the Founder & President
          </h2>
          <div className="gold-underline"></div>
        </div>
        <div className="leader-content">
          <div className="leader-image-col">
            <div className="leader-photo-frame">
              <img src="/president.jpg" alt="Founder & President Manjesh R. Naik" className="leader-photo" />
            </div>
            <div className="leader-id-card">
              <h3>Sri. Manjesh R. Naik</h3>
              <p className="leader-title-tag">Founder & President</p>
              <p className="leader-college-tag">Paramananda College of Nursing</p>
              <p className="leader-location-tag">📍 Bengaluru, Karnataka</p>
            </div>
          </div>
          <div className="leader-message-col">
            <div className="leader-quote-icon">"</div>
            <blockquote>
              It is with immense pride and joy that I welcome you to Paramananda College of Nursing —
              an institution I founded on the pillars of Compassion, Knowledge, and Excellence. Our vision is to
              nurture the next generation of skilled nurses who will serve humanity with dedication.
            </blockquote>
            <p>
              We are committed to providing world-class education, modern infrastructure, and clinical exposure
              that prepares our students to excel in any healthcare setting across the globe. The healthcare sector
              is evolving rapidly, and our goal is to ensure our students are always a step ahead, equipped with
              both the latest medical knowledge and timeless empathy.
            </p>
            <p>
              I invite you to be a part of the PCN family and embark on a rewarding journey in nursing.
              Together, let us build a healthier tomorrow.
            </p>
            <div className="leader-btns">
              <button className="btn btn-primary">Read Full Message</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default President;
